<script setup lang="ts">
import clsx from 'clsx';

const props = defineProps<{ class?: string }>();
const classes = clsx('mt-8 flex-1', props.class);
</script>

<template>
  <div aria-hidden="true" :class="classes" />
</template>
